import { useQuery } from '@tanstack/react-query';
import { eventMonitorApi } from '../api/eventMonitorApi';
import type { RecentEventsCondition } from '../types/eventMonitor';

/**
 * GET /api/eraf/event-monitor/recent — 5초 polling fallback
 * queryKey: ['event-monitor', 'list', condition]
 *
 * enabled=false 시 폴링 비활성화 (SSE primary 연결 시 polling 중단)
 */
export function useRecentEvents(
  condition: RecentEventsCondition,
  options?: { enabled?: boolean; refetchInterval?: number }
) {
  return useQuery({
    queryKey: ['event-monitor', 'list', condition],
    queryFn: () => eventMonitorApi.getRecent(condition),
    staleTime: 0,
    refetchInterval: options?.refetchInterval ?? undefined,
    enabled: options?.enabled !== false,
  });
}
